// extracted by mini-css-extract-plugin
module.exports = {"roles-select":"RolesSelect__roles-select___3eIJT","card":"RolesSelect__card___2Q-fW"};